// third
import type { FirebaseOptions } from "firebase/app";
import * as EnvheavenEnvironmentVarsProvider from "./envheaven-environment-vars-provider";
const ENV_VARS: EnvVarsData = EnvheavenEnvironmentVarsProvider.GetEnvVars();
export const environment = ENV_VARS;

export interface EnvVarsData
{
    // full env-map layer info
    ENVIRONMENT_MAP_INTERNAL_ID: string,
    ENVIRONMENT_MAP_PUBLIC_NAME: string,

    IS_PRODUCTION: boolean,
    IS_BETA: boolean,
    IS_DEVELOPMENT: boolean,
    IS_LOCAL: boolean,
    IS_FAKE_SHOWCASE: boolean,

    // ws-01-fe-01
    WEB_SITE_01_FE_01_PUBLIC_NAME: string,
    WEB_SITE_01_FE_01_INTERNAL_ID: string,

    WEB_SITE_01_FE_01_FULL_URL: string,
    WEB_SITE_01_FE_01_IP_ADDRESS: string,
    WEB_SITE_01_FE_01_PORT: string,
    WEB_SITE_01_FE_01_VERSION: string,

    // ws-01-api-01
    WEB_SITE_01_API_SERVER_01_PUBLIC_NAME: string,
    WEB_SITE_01_API_SERVER_01_INTERNAL_ID: string,

    WEB_SITE_01_API_SERVER_01_FULL_URL: string,
    WEB_SITE_01_API_SERVER_01_IP_ADDRESS: string,
    WEB_SITE_01_API_SERVER_01_PORT: string,
    WEB_SITE_01_API_SERVER_01_VERSION: string,

    // ws-01-rt-01
    WEB_SITE_01_RT_SERVER_01_PUBLIC_NAME: string,
    WEB_SITE_01_RT_SERVER_01_INTERNAL_ID: string,

    WEB_SITE_01_RT_SERVER_01_FULL_URL: string,
    WEB_SITE_01_RT_SERVER_01_IP_ADDRESS: string,
    WEB_SITE_01_RT_SERVER_01_PORT: string,
    WEB_SITE_01_RT_SERVER_01_VERSION: string,

    // ws-01-cdn-01
    WEB_SITE_01_CDN_01_PUBLIC_NAME: string,
    WEB_SITE_01_CDN_01_INTERNAL_ID: string,

    WEB_SITE_01_CDN_01_FULL_URL: string,
    WEB_SITE_01_CDN_01_IP_ADDRESS: string,
    WEB_SITE_01_CDN_01_PORT: string,
    WEB_SITE_01_CDN_01_VERSION: string,
}



export const ProductionEnvironmentName = 'prod';
export const BetaEnvironmentName = 'beta';
export const DevelopmentEnvironmentName = 'dev';
export const LocalEnvironmentName = 'local';

// export const environment: EnvironmentData = {
//     API_URL: 'http://localhost:3001',
//     CDN_URL: 'http://localhost:3002',
//     APP_VERSION: "0.0.0",

//     // ENVIRONMENT_NAME: DevelopmentEnvironmentName,
//     ENVIRONMENT_NAME: LocalEnvironmentName,
//     VAPID_PUBLIC_KEY: "*****************************************",
// };

export interface EnvironmentData
{
    API_URL: string,
    CDN_URL: string,
    APP_VERSION: string,

    ENVIRONMENT_NAME: string,

    VAPID_PUBLIC_KEY: string,
}

export const firebaseEnvironment: FirebaseOptions = {
    "projectId": "INSERT-PROJECT-ID",
    "appId": "INSERT-APP-ID",
    "storageBucket": "INSERT-STORAGE-BUCKET",
    "apiKey": "INSERT-API-KEY",
    "authDomain": "INSERT-AUTH-DOMAIN",
    "messagingSenderId": "INSERT-MESSAGING-ID",
    "measurementId": "INSERT-MEASUMENT-ID"
};

export class AppEnvironmentHandler
{
    static GetEnviromentCollectionPrefix = () =>
    {
        let value = '';

        // value += environment.ENVIRONMENT_NAME + '-';
        value += environment.ENVIRONMENT_MAP_INTERNAL_ID + '-';

        return value;
    }

    static IsProd = () =>
    {
        let value = false;

        // value = environment.ENVIRONMENT_NAME == ProductionEnvironmentName
        value = environment.IS_PRODUCTION;

        return value;
    }

    static IsLocal = () =>
    {
        let value = false;

        // value = environment.ENVIRONMENT_NAME == LocalEnvironmentName
        value = environment.IS_LOCAL;

        return value;
    }

    static DoIfProduction = (callback: () => void) =>
    {
        if (AppEnvironmentHandler.IsProd())
            callback();
    }

    static DoIfLocal = (callback: () => void) =>
    {
        if (AppEnvironmentHandler.IsLocal())
            callback();
    }
}
